import { Grid, Typography } from "@sidelinesports/fan-design-system";
import styles from "./PostGamePositionTitle.module.css";

export const PostGamePositionTitle = ({ position }: { position: number }) => (
  <Grid gap={4}>
    <Typography size="md" className={styles.title}>
      {toOrdinal(position)}
    </Typography>
    <div className={styles.underline} />
  </Grid>
);

const toOrdinal = (num: number): string => {
  const suffixes = ["th", "st", "nd", "rd"];
  const value = num % 100;
  return num + (suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0]);
};
